import BaseAPI from "@/api/BaseAPI";

export class AdminAPI extends BaseAPI{
    constructor() {
        super('/adminData');
    }
    getAdminInfo(){
        return this.http.get('/get',{})
    }

    /**
     * @param {1 | 2 | 3} stageId
     * */
    setNewStage(stageId = 1){
        return this.http.post(`/update/stage?stageValue=${stageId}`,{})
    }

    getOrgAppeals(){
        return this.http.get('/appeal/all/org/get')
    }
    getFormsFivesAppeals(){
        return this.http.get('/appeal/all/get')
    }
}
export default new AdminAPI()